module.exports = [{"id":1,"code":"","name":"客服建議","en_name":"Customer service suggestions"},{"id":2,"code":"","name":"新品推薦","en_name":"New Product"},{"id":3,"code":"","name":"缺貨回報","en_name":"Out of Stock Return"},{"id":4,"code":"","name":"買貴回報","en_name":"Buy expensive returns"},{"id":5,"code":"","name":"服務建議","en_name":"Service suggestion"}]


//////////////////
// WEBPACK FOOTER
// ./src/blocks/customer-service/querySubjectOptions.json
// module id = 321
// module chunks = 0